module.exports = __webpack_public_path__ + "static/media/Mall1930_2.ccbe0eda.jpg";